import { createFileRoute } from "@tanstack/react-router";
import WhatYouNeed from "@/features/onboarding/pages/what-you-need/WhatYouNeed";

export const Route = createFileRoute("/$locale/$partner/_onboarding/what-you-need")({
	component: WhatYouNeed,
});
